(() => {
  const maxSlidesForPage = () => {
    const path = window.location.pathname || "";
    if (path.includes("/products/hs-handwaaier-met-koord-meerdere-teksten")) return 60;
    return 24;
  };

  const capGallery = (gallery, maxSlides = maxSlidesForPage()) => {
    if (!gallery || gallery.dataset.mapsyMediaCapped === "true") return;
    gallery.querySelectorAll("[data-product-main-media] > .swiper-slide").forEach((slide, index) => {
      if (index >= maxSlides) slide.remove();
    });
    gallery.querySelectorAll(".product-gallery-thumbs .swiper-wrapper > .swiper-slide").forEach((slide, index) => {
      if (index >= maxSlides) slide.remove();
    });
    gallery.dataset.mapsyMediaCapped = "true";
  };

  document.querySelectorAll("product-media").forEach((gallery) => capGallery(gallery));
})();
